<template>
  <div class="stepper">
    <div v-if="collapsedMilestones.length">
    <ul class="stepper__milestone">
      <li v-for="(milestone) in collapsedMilestones"
        :key="milestone.id"
        :class="`stepper__milestone--${milestone.status}`"
      >
        <router-link v-if="milestone.status !== 'pending'" :to="`/app/profile/${milestone.id}`" active-class="stepper__milestone--current">
          <span>
            <ds ds="icon" v-if="milestone.status === 'complete'" name="checkmark" />
            <ds ds="icon" v-else :name="milestone.icon" />
            {{milestone.label}}
          </span>
        </router-link>
        <span v-else>
          <ds v-if="milestone.icon" ds="icon" :name="milestone.icon" />
          <ds v-else ds="icon" name="close" />
          {{milestone.label}}
        </span>

        <ul v-if="milestone.status !== 'pending'" class="stepper__section">
          <li v-for="(section) in milestone.sections"
            :key="section.id"
            :class="`stepper__section--${section.status}`"
          >
            <router-link v-if="section.status !== 'pending'" :to="`/app/profile/${milestone.id}/${section.id}`" active-class="stepper__section--current" >
              <span>
                <ds ds="icon" v-if="section.status === 'complete'" name="checkmark" />
                <ds ds="icon" v-else-if="section.status === 'locked'" name="lock" />
                <ds ds="icon" v-else name="close" />
                {{section.label}}
              </span>
            </router-link>
            <span v-else>
              <ds ds="icon" name="close" />
              {{section.label}}
            </span>
          </li>
        </ul>
      </li>
    </ul>
    </div>
    <Loader v-else />
  </div>
</template>

<script>

import { Loader } from '@/components';
import { mapGetters } from 'vuex';

export default {
  name: 'Stepper',
  components: { Loader },
  computed: {
    ...mapGetters({ milestones: 'qualification/milestones' }),
    collapsedMilestones () {
      return this.milestones.map(milestone => milestone.sections.length === 1 ? {
        ...milestone,
        ...{
          sections: []
        }
      } : milestone);
    }
  }
};
</script>

<style lang="less">
@import "~@/utils.less";

.stepper {
  color: var(--black);
  ._text\:xs;

  ds-icon {
    margin-right: 0.7rem;
    color: var(--white);
    border-color: var(--white);
    border-radius: 50%;

    svg {
      fill: var(--white);
    }
  }

  li {
    list-style: none;

    span {
      display: inline-flex;
      min-height: 2rem;
      text-align: left;
      line-height: 1.1rem;
    }
  }

  a:link {
    color: inherit;
    text-decoration: none;
  }

  &__milestone {
    li {
      background: linear-gradient(180deg, var(--neutral-600), var(--neutral-600));
      background-position: 1.85rem;
      background-repeat: repeat-y;
      background-size: 1px auto;
      padding-left: 1rem;
      ._text\:sm;

      span {
        min-height: 2.5rem;
        line-height: 1.85rem;
      }
    }

    li:last-child {
      background: none;
    }

    ds-icon {
      background-color: var(--primary);
      height: 1.8rem;
      width: 1.8rem;
      padding: 0.5rem;

      svg {
        padding-bottom: 0.2rem;
      }
    }

    &--current {
      a:active, a:focus, a:visited, a:hover, a:link {
        font-weight: 800;
        color: var(--black);
      }

      ds-icon {
        background-color: var(--primary);
      }
    }

    &--active {

      > a {
        ._text\:sm;
        font-weight: 500;

        span {
          line-height: 1.8rem;
        }
      }

      ds-icon {
        height: 1.875rem;
        width: 1.875rem;
        background-color: var(--primary);
      }
    }

    &--complete {

      > a {
        margin-left: 0.385rem;
        > span {
          line-height: 1rem;
        }
      }

      ds-icon {
        background-color: var(--primary);
        height: 1.125rem;
        width: 1.125rem;
        padding: 0.25rem;
        margin-right: 1rem;

        svg {
          padding-bottom: 0.4rem;
        }
      }
    }

    &--pending {
      color: var(--neutral-900);

      ds-icon {
        color: var(--neutral-900);
        background-color: var(--neutral-300);

        svg {
          fill: var(--neutral-900);
        }
      }
    }
  }

  &__section {
    li {
      background: none;
      display: flex;

      ._text\:xs;

      a {
        padding: 0 1rem 0 0.9rem;
        margin: 0.5rem 0.8rem 0 0.7em;
        width: 100%;
      }

      span {
        min-height: 2.25rem;
        display: flex;
        align-items: center;
      }

    }

    ds-icon {
      height: 1.125rem;
      width: 1.125rem;
      padding: 0.25rem;

      svg {
        padding-bottom: 0.4rem;
      }
    }

    &--current {
      font-weight: 500;
      background: var(--neutral-400)!important;
    }

    &--active {
      a {
        font-weight: 500;
      }
      ds-icon {
        background-color: var(--neutral-600);

        svg {
          fill: var(--black);
          opacity: 0.6;
        }
      }

    }

    &--complete {
      color: var(--black);

      ds-icon {
        background-color: var(--primary);
      }
    }

    &--pending {
      color: var(--neutral-900);
      margin-top: 0.7rem;

      span {
        padding: 0 1rem 0.2rem 0.9rem;
        margin-left: 0.7rem;
      }

      ds-icon {
        color: var(--neutral-900);
        background-color: var(--neutral-300);

        svg {
          fill: var(--neutral-900);
        }
      }
    }
  }
}
</style>
